export default [
    {
        path: 'ficha-complementar',
        component: () => import(
            /* webpackChunkName: 'atencao-basica-ficha-complementar' */
            '@/views/atencao-basica/ficha-complementar/Index'
        ),
        redirect: 'ficha-complementar/index',
        children: [
            {
                name: 'atencao-basica-ficha-complementar-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'atencao-basica-ficha-complementar' */
                    '@/views/atencao-basica/ficha-complementar/List'
                )
            },
            {
                name: 'atencao-basica-ficha-complementar-historico-atendimento',
                path: 'historico-atendimento/:id',
                props: route => ({
                    id: parseInt(route.params.id)
                }),
                component: () => import(
                    /* webpackChunkName: 'atencao-basica-ficha-complementar' */
                    '@/views/atencao-basica/ficha-complementar/Historico'
                )
            },
            {
                name: 'atencao-basica-ficha-complementar-create',
                path: 'create/:id',
                props: route => ({
                    id: parseInt(route.params.id)
                }),
                component: () => import(
                    /* webpackChunkName: 'atencao-basica-ficha-complementar' */
                    '@/views/atencao-basica/ficha-complementar/Form'
                )
            },
            {
                name: 'atencao-basica-ficha-complementar-edit',
                path: 'edit/:id',
                props: route => ({
                    id: parseInt(route.params.id)
                }),
                component: () => import(
                    /* webpackChunkName: 'atencao-basica-ficha-complementar' */
                    '@/views/atencao-basica/ficha-complementar/Form'
                )
            },

        ]
    }
]